import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  // State management
  const [activeTab, setActiveTab] = useState('suck');
  const [activeSubTab, setActiveSubTab] = useState({
    suck: 'panel-low',
    wash: 'panel-fake-down',
    rise: 'panel-fast-rise',
    sell: 'panel-fake-break-sell'
  });
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showMemberCenterModal, setShowMemberCenterModal] = useState(false);
  const [showPaymentSection, setShowPaymentSection] = useState(false);
  
  // Mock user subscriptions
  const [userSubscriptions, setUserSubscriptions] = useState({
    suck: false,
    wash: false,
    rise: false,
    sell: false
  });

  // Breadcrumb labels mapping
  const tabLabels = {
    'suck': '吸筹阶段',
    'wash': '洗盘阶段',
    'rise': '拉升阶段',
    'sell': '出货阶段',
    'must-see': '主力必看'
  };

  // Check login status on component mount
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    setIsLoggedIn(!!token);
  }, []);

  // Handle tab change
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  // Handle sub-tab change
  const handleSubTabChange = (tab, subTab) => {
    setActiveSubTab({
      ...activeSubTab,
      [tab]: subTab
    });
  };

  // Mock login function
  const handleLogin = (e) => {
    e.preventDefault();
    // Normally would validate and send to server
    localStorage.setItem('authToken', 'mock-token');
    setIsLoggedIn(true);
    setShowLoginModal(false);
  };

  // Mock register function
  const handleRegister = (e) => {
    e.preventDefault();
    // Normally would validate and send to server
    localStorage.setItem('authToken', 'mock-token');
    setIsLoggedIn(true);
    setShowRegisterModal(false);
  };

  // Mock logout function
  const handleLogout = () => {
    localStorage.removeItem('authToken');
    setIsLoggedIn(false);
    setShowMemberCenterModal(false);
  };

  // Simplified content loading
  const loadModuleContent = (moduleId) => {
    // This would normally fetch content from backend
    return "模块内容加载中...";
  };

  // Function to generate membership cards
  const renderMembershipCards = () => {
    return (
      <div className="membership-cards">
        <div className="membership-card">
          <div className="card-header">基础会员</div>
          <div className="card-price">
            ¥99
            <span className="card-period">/月</span>
          </div>
          <div className="card-divider"></div>
          <div className="card-benefits">
            <ul>
              <li>权益1</li>
              <li>权益2</li>
              <li>权益3</li>
            </ul>
          </div>
          <a href="#" className="card-button" onClick={(e) => {e.preventDefault(); setShowPaymentSection(true);}}>购买</a>
        </div>
        <div className="membership-card">
          <div className="card-header">高级会员</div>
          <div className="card-price">
            ¥299
            <span className="card-period">/月</span>
          </div>
          <div className="card-divider"></div>
          <div className="card-benefits">
            <ul>
              <li>权益1</li>
              <li>权益2</li>
              <li>权益3</li>
            </ul>
          </div>
          <a href="#" className="card-button" onClick={(e) => {e.preventDefault(); setShowPaymentSection(true);}}>购买</a>
        </div>
        <div className="membership-card">
          <div className="card-header">VIP会员</div>
          <div className="card-price">
            ¥999
            <span className="card-period">/月</span>
          </div>
          <div className="card-divider"></div>
          <div className="card-benefits">
            <ul>
              <li>权益1</li>
              <li>权益2</li>
              <li>权益3</li>
            </ul>
          </div>
          <a href="#" className="card-button" onClick={(e) => {e.preventDefault(); setShowPaymentSection(true);}}>购买</a>
        </div>
      </div>
    );
  };

  return (
    <div>
      {/* Main Navigation */}
      <nav className="main-nav">
        <div className="container">
          <ul className="main-nav-list">
            <li><a href="#must-see" onClick={(e) => {e.preventDefault(); handleTabChange('must-see');}}>庄家操作解码：</a></li>
            <li><a href="#suck" className={activeTab === 'suck' ? 'active' : ''} onClick={(e) => {e.preventDefault(); handleTabChange('suck');}}>一 吸筹（建仓）</a></li>
            <li><a href="#wash" className={activeTab === 'wash' ? 'active' : ''} onClick={(e) => {e.preventDefault(); handleTabChange('wash');}}>二 洗盘</a></li>
            <li><a href="#rise" className={activeTab === 'rise' ? 'active' : ''} onClick={(e) => {e.preventDefault(); handleTabChange('rise');}}>三 拉升</a></li>
            <li><a href="#sell" className={activeTab === 'sell' ? 'active' : ''} onClick={(e) => {e.preventDefault(); handleTabChange('sell');}}>四 出货</a></li>
          </ul>
        </div>
      </nav>

      {/* Main Content */}
      <main className="container">
        {/* Breadcrumbs */}
        <div className="breadcrumbs">
          首页 <span>{'>'}</span> <span>{tabLabels[activeTab]}</span>
        </div>

        {/* Tab Content - 吸筹阶段 */}
        <div id="suck" className={`tab-content ${activeTab === 'suck' ? 'active' : ''}`}>
          <div className="section-card">
            <div className="section-header">第一阶段：吸筹（建仓）</div>
            <div className="section-content">
              <div className="section-target">
                目标：在低位阶段收集足够筹码，而不引起市场关注
              </div>
              <div className="tab-nav">
                <button 
                  className={`tab-button ${activeSubTab.suck === 'panel-low' ? 'active' : ''}`}
                  onClick={() => handleSubTabChange('suck', 'panel-low')}
                >
                  低调建仓
                </button>
                <button 
                  className={`tab-button ${activeSubTab.suck === 'panel-press' ? 'active' : ''}`}
                  onClick={() => handleSubTabChange('suck', 'panel-press')}
                >
                  打压股价
                </button>
                <button 
                  className={`tab-button ${activeSubTab.suck === 'panel-cross' ? 'active' : ''}`}
                  onClick={() => handleSubTabChange('suck', 'panel-cross')}
                >
                  对倒交易
                </button>
              </div>
              
              {/* 低调建仓 Panel */}
              <div id="panel-low" className={`content-panel ${activeSubTab.suck === 'panel-low' ? 'active' : ''}`}>
                <div className="panel-column">
                  <h3 className="panel-title">低调建仓 - 特征说明</h3>
                  <ul className="panel-list">
                    <li>交易量保持在20日均量的50%以内</li>
                    <li>大单买入分批进场</li>
                    <li>股价震荡横盘，主力以低价增仓</li>
                    <li>筹码平衡，主力持仓比例增加</li>
                  </ul>
                </div>
                <div className="panel-column">
                  <h3 className="panel-title">操作特点</h3>
                  <ul className="panel-list">
                    <li>窄幅震荡，便于吸筹</li>
                    <li>暗中建仓</li>
                    <li>成交量平稳</li>
                    <li>中长期不作赢利测算</li>
                  </ul>
                </div>
              </div>
              
              {/* Panel Press - 内容省略 */}
              <div id="panel-press" className={`content-panel ${activeSubTab.suck === 'panel-press' ? 'active' : ''}`}>
                {/* Content for panel-press */}
              </div>
              
              {/* Panel Cross - 内容省略 */}
              <div id="panel-cross" className={`content-panel ${activeSubTab.suck === 'panel-cross' ? 'active' : ''}`}>
                {/* Content for panel-cross */}
              </div>
              
              {/* 数据统计区域 */}
              <div className="stats-section">
                <h3 className="stats-title">今日发现的处于"吸筹"阶段的股票（6只）</h3>
                <div className="stats-content">
                  <div className="stats-icon">Ш</div>
                </div>
              </div>
              
              {/* 动态内容区域（由订阅状态决定显示内容） */}
              <div className="contentSection">
                {userSubscriptions.suck ? (
                  <div>加载订阅内容...{loadModuleContent('suck')}</div>
                ) : (
                  <>
                    <a href="#" className="upgrade-button" onClick={(e) => {e.preventDefault(); setShowPaymentSection(true);}}>
                      升级会员查看详情
                    </a>
                    <h3 style={{textAlign: 'center', margin: '20px 0'}}>选择会员套餐</h3>
                    {renderMembershipCards()}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Tab Content - 洗盘阶段 */}
        <div id="wash" className={`tab-content ${activeTab === 'wash' ? 'active' : ''}`}>
          <div className="section-card">
            <div className="section-header">第二阶段：洗盘</div>
            <div className="section-content">
              <div className="section-target">
                目标：震荡洗出部分散户持仓，打压市场信心，为主力后续上攻做准备
              </div>
              <div className="tab-nav">
                <button 
                  className={`tab-button ${activeSubTab.wash === 'panel-fake-down' ? 'active' : ''}`}
                  onClick={() => handleSubTabChange('wash', 'panel-fake-down')}
                >
                  假阴洗盘
                </button>
                <button 
                  className={`tab-button ${activeSubTab.wash === 'panel-shake' ? 'active' : ''}`}
                  onClick={() => handleSubTabChange('wash', 'panel-shake')}
                >
                  震荡洗盘
                </button>
                <button 
                  className={`tab-button ${activeSubTab.wash === 'panel-violent' ? 'active' : ''}`}
                  onClick={() => handleSubTabChange('wash', 'panel-violent')}
                >
                  暴力洗盘
                </button>
              </div>
              
              {/* 假阴洗盘 Panel */}
              <div id="panel-fake-down" className={`content-panel ${activeSubTab.wash === 'panel-fake-down' ? 'active' : ''}`}>
                <div className="panel-column">
                  <h3 className="panel-title">假阴洗盘 - 特征说明</h3>
                  <ul className="panel-list">
                    <li>股价快速下跌后迅速回升</li>
                    <li>卖盘突然放量，但买盘很快接手</li>
                    <li>K线出现带有长下影线的阴线</li>
                    <li>分时图上常见大幅跳水后拉回</li>
                  </ul>
                </div>
                <div className="panel-column">
                  <h3 className="panel-title">操作特点</h3>
                  <ul className="panel-list">
                    <li>短线迅速下跌制造恐慌</li>
                    <li>主力暗中承接恐慌盘</li>
                    <li>成交量先放大后迅速萎缩</li>
                    <li>盘后持仓数据变化明显</li>
                  </ul>
                </div>
              </div>
              
              {/* 震荡洗盘 Panel */}
              <div id="panel-shake" className={`content-panel ${activeSubTab.wash === 'panel-shake' ? 'active' : ''}`}>
                <div className="panel-column">
                  <h3 className="panel-title">震荡洗盘 - 特征说明</h3>
                  <ul className="panel-list">
                    <li>股价在一定区间内反复震荡</li>
                    <li>上下空间有明显压力位和支撑位</li>
                    <li>成交量呈现波浪状变化</li>
                    <li>持续时间较长，消耗投资者耐心</li>
                  </ul>
                </div>
                <div className="panel-column">
                  <h3 className="panel-title">操作特点</h3>
                  <ul className="panel-list">
                    <li>盘中反复无常的震荡</li>
                    <li>主力在特定价位区间吸筹</li>
                    <li>利用时间换空间策略</li>
                    <li>成交结构显示大资金逐步增持</li>
                  </ul>
                </div>
              </div>
              
              {/* 暴力洗盘 Panel */}
              <div id="panel-violent" className={`content-panel ${activeSubTab.wash === 'panel-violent' ? 'active' : ''}`}>
                <div className="panel-column">
                  <h3 className="panel-title">暴力洗盘 - 特征说明</h3>
                  <ul className="panel-list">
                    <li>股价短期内大幅下跌</li>
                    <li>放量大跌后成交量迅速萎缩</li>
                    <li>技术指标严重超卖</li>
                    <li>恐慌情绪蔓延，散户大量割肉</li>
                  </ul>
                </div>
                <div className="panel-column">
                  <h3 className="panel-title">操作特点</h3>
                  <ul className="panel-list">
                    <li>强势打压，制造恐慌氛围</li>
                    <li>利用负面消息配合打压</li>
                    <li>大资金借机大量收集筹码</li>
                    <li>洗盘结束后往往有强势反弹</li>
                  </ul>
                </div>
              </div>
              
              {/* 数据统计区域 */}
              <div className="stats-section">
                <h3 className="stats-title">今日发现的处于"洗盘"阶段的股票（8只）</h3>
                <div className="stats-content">
                  <div className="stats-icon">Ш</div>
                </div>
              </div>
              
              {/* 动态内容区域（由订阅状态决定显示内容） */}
              <div className="contentSection">
                {userSubscriptions.wash ? (
                  <div>加载订阅内容...{loadModuleContent('wash')}</div>
                ) : (
                  <>
                    <a href="#" className="upgrade-button" onClick={(e) => {e.preventDefault(); setShowPaymentSection(true);}}>
                      升级会员查看详情
                    </a>
                    <h3 style={{textAlign: 'center', margin: '20px 0'}}>选择会员套餐</h3>
                    {renderMembershipCards()}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Tab Content - 拉升阶段 */}
        <div id="rise" className={`tab-content ${activeTab === 'rise' ? 'active' : ''}`}>
          <div className="section-card">
            <div className="section-header">第三阶段：拉升</div>
            <div className="section-content">
              <div className="section-target">
                目标：主力持筹充足后，拉升股价吸引散户跟风，为后续出货做准备
              </div>
              <div className="tab-nav">
                <button 
                  className={`tab-button ${activeSubTab.rise === 'panel-fast-rise' ? 'active' : ''}`}
                  onClick={() => handleSubTabChange('rise', 'panel-fast-rise')}
                >
                  快速拉升
                </button>
                <button 
                  className={`tab-button ${activeSubTab.rise === 'panel-step-rise' ? 'active' : ''}`}
                  onClick={() => handleSubTabChange('rise', 'panel-step-rise')}
                >
                  阶梯式拉升
                </button>
                <button 
                  className={`tab-button ${activeSubTab.rise === 'panel-breakthrough' ? 'active' : ''}`}
                  onClick={() => handleSubTabChange('rise', 'panel-breakthrough')}
                >
                  突破性拉升
                </button>
              </div>
              
              {/* 快速拉升 Panel */}
              <div id="panel-fast-rise" className={`content-panel ${activeSubTab.rise === 'panel-fast-rise' ? 'active' : ''}`}>
                <div className="panel-column">
                  <h3 className="panel-title">快速拉升 - 特征说明</h3>
                  <ul className="panel-list">
                    <li>股价短期内连续大幅上涨</li>
                    <li>成交量明显放大，换手率高</li>
                    <li>多根大阳线，涨幅显著</li>
                    <li>技术指标处于超买区域</li>
                  </ul>
                </div>
                <div className="panel-column">
                  <h3 className="panel-title">操作特点</h3>
                  <ul className="panel-list">
                    <li>主力连续拉升制造赚钱效应</li>
                    <li>利用热点题材引发市场关注</li>
                    <li>放量上攻，资金持续流入</li>
                    <li>拉升过程中不回头，气势如虹</li>
                  </ul>
                </div>
              </div>
              
              {/* 阶梯式拉升 Panel */}
              <div id="panel-step-rise" className={`content-panel ${activeSubTab.rise === 'panel-step-rise' ? 'active' : ''}`}>
                <div className="panel-column">
                  <h3 className="panel-title">阶梯式拉升 - 特征说明</h3>
                  <ul className="panel-list">
                    <li>股价呈现上涨-横盘-上涨模式</li>
                    <li>每段上涨后有调整整固阶段</li>
                    <li>成交量适中，有规律波动</li>
                    <li>走势更稳健，持续时间较长</li>
                  </ul>
                </div>
                <div className="panel-column">
                  <h3 className="panel-title">操作特点</h3>
                  <ul className="panel-list">
                    <li>拉升-调整交替进行</li>
                    <li>突破重要阻力位时放量</li>
                    <li>调整时间逐渐缩短</li>
                    <li>形成稳步上扬的趋势通道</li>
                  </ul>
                </div>
              </div>
              
              {/* 突破性拉升 Panel */}
              <div id="panel-breakthrough" className={`content-panel ${activeSubTab.rise === 'panel-breakthrough' ? 'active' : ''}`}>
                <div className="panel-column">
                  <h3 className="panel-title">突破性拉升 - 特征说明</h3>
                  <ul className="panel-list">
                    <li>长期横盘后突然放量上涨</li>
                    <li>突破重要技术阻力位</li>
                    <li>成交量爆发式增长</li>
                    <li>股价突破前期高点或重要均线</li>
                  </ul>
                </div>
                <div className="panel-column">
                  <h3 className="panel-title">操作特点</h3>
                  <ul className="panel-list">
                    <li>前期积蓄能量，量价配合</li>
                    <li>利用重要时间节点或消息触发</li>
                    <li>突破前蓄势，突破后加速</li>
                    <li>主力资金推动，散户跟风</li>
                  </ul>
                </div>
              </div>
              
              {/* 数据统计区域 */}
              <div className="stats-section">
                <h3 className="stats-title">今日发现的处于"拉升"阶段的股票（12只）</h3>
                <div className="stats-content">
                  <div className="stats-icon">Ш</div>
                </div>
              </div>
              
              {/* 动态内容区域（由订阅状态决定显示内容） */}
              <div className="contentSection">
                {userSubscriptions.rise ? (
                  <div>加载订阅内容...{loadModuleContent('rise')}</div>
                ) : (
                  <>
                    <a href="#" className="upgrade-button" onClick={(e) => {e.preventDefault(); setShowPaymentSection(true);}}>
                      升级会员查看详情
                    </a>
                    <h3 style={{textAlign: 'center', margin: '20px 0'}}>选择会员套餐</h3>
                    {renderMembershipCards()}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Tab Content - 出货阶段 */}
        <div id="sell" className={`tab-content ${activeTab === 'sell' ? 'active' : ''}`}>
          <div className="section-card">
            <div className="section-header">第四阶段：出货</div>
            <div className="section-content">
              <div className="section-target">
                目标：主力高位减持获利离场，将筹码转移给追高的散户
              </div>
              <div className="tab-nav">
                <button 
                  className={`tab-button ${activeSubTab.sell === 'panel-fake-break-sell' ? 'active' : ''}`}
                  onClick={() => handleSubTabChange('sell', 'panel-fake-break-sell')}
                >
                  假突破出货
                </button>
                <button 
                  className={`tab-button ${activeSubTab.sell === 'panel-high-sell' ? 'active' : ''}`}
                  onClick={() => handleSubTabChange('sell', 'panel-high-sell')}
                >
                  高位振荡出货
                </button>
                <button 
                  className={`tab-button ${activeSubTab.sell === 'panel-news-sell' ? 'active' : ''}`}
                  onClick={() => handleSubTabChange('sell', 'panel-news-sell')}
                >
                  利好出货
                </button>
              </div>
              
              {/* 假突破出货 Panel */}
              <div id="panel-fake-break-sell" className={`content-panel ${activeSubTab.sell === 'panel-fake-break-sell' ? 'active' : ''}`}>
                <div className="panel-column">
                  <h3 className="panel-title">假突破出货 - 特征说明</h3>
                  <ul className="panel-list">
                    <li>股价突破重要阻力位后无法持续上行</li>
                    <li>成交量异常放大但股价涨幅有限</li>
                    <li>突破后迅速回落，跌破突破点</li>
                    <li>主力持仓比例开始明显下降</li>
                  </ul>
                </div>
                <div className="panel-column">
                  <h3 className="panel-title">操作特点</h3>
                  <ul className="panel-list">
                    <li>制造突破假象吸引跟风盘</li>
                    <li>趁高位放量出货</li>
                    <li>利用技术突破激发买盘</li>
                    <li>出货完成后迅速打压股价</li>
                  </ul>
                </div>
              </div>
              
              {/* 高位振荡出货 Panel */}
              <div id="panel-high-sell" className={`content-panel ${activeSubTab.sell === 'panel-high-sell' ? 'active' : ''}`}>
                <div className="panel-column">
                  <h3 className="panel-title">高位振荡出货 - 特征说明</h3>
                  <ul className="panel-list">
                    <li>股价在高位区间内反复震荡</li>
                    <li>成交量持续处于高位但涨幅收窄</li>
                    <li>K线呈现高位箱体整理形态</li>
                    <li>分时图显示买盘力量逐渐减弱</li>
                  </ul>
                </div>
                <div className="panel-column">
                  <h3 className="panel-title">操作特点</h3>
                  <ul className="panel-list">
                    <li>高位维持股价不急于下跌</li>
                    <li>震荡过程中逐步出货</li>
                    <li>出货周期较长，避免引发恐慌</li>
                    <li>成交结构显示大资金逐步撤离</li>
                  </ul>
                </div>
              </div>
              
              {/* 利好出货 Panel */}
              <div id="panel-news-sell" className={`content-panel ${activeSubTab.sell === 'panel-news-sell' ? 'active' : ''}`}>
                <div className="panel-column">
                  <h3 className="panel-title">利好出货 - 特征说明</h3>
                  <ul className="panel-list">
                    <li>公司发布重大利好消息</li>
                    <li>股价大幅高开但无法持续上涨</li>
                    <li>利好后成交量突然放大</li>
                    <li>股价冲高回落，尾盘走弱</li>
                  </ul>
                </div>
                <div className="panel-column">
                  <h3 className="panel-title">操作特点</h3>
                  <ul className="panel-list">
                    <li>利用重大利好消息吸引买盘</li>
                    <li>趁利好刺激下的高位放量出货</li>
                    <li>出货前可能有意造势拉高股价</li>
                    <li>利好兑现后股价往往明显回落</li>
                  </ul>
                </div>
              </div>
              
              {/* 数据统计区域 */}
              <div className="stats-section">
                <h3 className="stats-title">今日发现的处于"出货"阶段的股票（5只）</h3>
                <div className="stats-content">
                  <div className="stats-icon">Ш</div>
                </div>
              </div>
              
              {/* 动态内容区域（由订阅状态决定显示内容） */}
              <div className="contentSection">
                {userSubscriptions.sell ? (
                  <div>加载订阅内容...{loadModuleContent('sell')}</div>
                ) : (
                  <>
                    <a href="#" className="upgrade-button" onClick={(e) => {e.preventDefault(); setShowPaymentSection(true);}}>
                      升级会员查看详情
                    </a>
                    <h3 style={{textAlign: 'center', margin: '20px 0'}}>选择会员套餐</h3>
                    {renderMembershipCards()}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Modal for Login */}
      {showLoginModal && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-header">
              <h2>登录</h2>
              <button className="close-button" onClick={() => setShowLoginModal(false)}>×</button>
            </div>
            <div className="modal-content">
              <form onSubmit={handleLogin}>
                <div className="form-group">
                  <label>用户名</label>
                  <input type="text" placeholder="请输入用户名" required />
                </div>
                <div className="form-group">
                  <label>密码</label>
                  <input type="password" placeholder="请输入密码" required />
                </div>
                <div className="form-actions">
                  <button type="submit" className="primary-button">登录</button>
                  <div className="form-links">
                    <a href="#" onClick={(e) => {e.preventDefault(); setShowLoginModal(false); setShowRegisterModal(true);}}>注册新账号</a>
                    <a href="#" onClick={(e) => {e.preventDefault();}}>忘记密码？</a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Modal for Register */}
      {showRegisterModal && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-header">
              <h2>注册</h2>
              <button className="close-button" onClick={() => setShowRegisterModal(false)}>×</button>
            </div>
            <div className="modal-content">
              <form onSubmit={handleRegister}>
                <div className="form-group">
                  <label>用户名</label>
                  <input type="text" placeholder="请设置用户名" required />
                </div>
                <div className="form-group">
                  <label>邮箱</label>
                  <input type="email" placeholder="请输入邮箱" required />
                </div>
                <div className="form-group">
                  <label>密码</label>
                  <input type="password" placeholder="请设置密码" required />
                </div>
                <div className="form-group">
                  <label>确认密码</label>
                  <input type="password" placeholder="请再次输入密码" required />
                </div>
                <div className="form-agree">
                  <input type="checkbox" id="agree" required />
                  <label htmlFor="agree">
                    我已阅读并同意
                    <a href="#" onClick={(e) => {e.preventDefault(); setShowTermsModal(true);}}>服务条款</a>
                    和
                    <a href="#" onClick={(e) => {e.preventDefault(); setShowPrivacyModal(true);}}>隐私政策</a>
                  </label>
                </div>
                <div className="form-actions">
                  <button type="submit" className="primary-button">注册</button>
                  <div className="form-links">
                    <a href="#" onClick={(e) => {e.preventDefault(); setShowRegisterModal(false); setShowLoginModal(true);}}>已有账号？登录</a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Modal for Terms */}
      {showTermsModal && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-header">
              <h2>服务条款</h2>
              <button className="close-button" onClick={() => setShowTermsModal(false)}>×</button>
            </div>
            <div className="modal-content">
              <div className="terms-content">
                <h3>服务条款</h3>
                <p>这里是服务条款内容...</p>
              </div>
              <div className="modal-footer">
                <button className="primary-button" onClick={() => setShowTermsModal(false)}>我已阅读并同意</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal for Privacy */}
      {showPrivacyModal && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-header">
              <h2>隐私政策</h2>
              <button className="close-button" onClick={() => setShowPrivacyModal(false)}>×</button>
            </div>
            <div className="modal-content">
              <div className="terms-content">
                <h3>隐私政策</h3>
                <p>这里是隐私政策内容...</p>
              </div>
              <div className="modal-footer">
                <button className="primary-button" onClick={() => setShowPrivacyModal(false)}>我已阅读并同意</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal for Member Center */}
      {showMemberCenterModal && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-header">
              <h2>会员中心</h2>
              <button className="close-button" onClick={() => setShowMemberCenterModal(false)}>×</button>
            </div>
            <div className="modal-content">
              <div className="member-center">
                <div className="member-info">
                  <h3>会员信息</h3>
                  <p><strong>用户名：</strong> 用户001</p>
                  <p><strong>会员等级：</strong> {userSubscriptions.suck || userSubscriptions.wash || userSubscriptions.rise || userSubscriptions.sell ? '已订阅' : '免费会员'}</p>
                  <p><strong>到期时间：</strong> {userSubscriptions.suck || userSubscriptions.wash || userSubscriptions.rise || userSubscriptions.sell ? '2023-12-31' : '无'}</p>
                </div>
                <div className="member-actions">
                  <button className="primary-button" onClick={() => setShowPaymentSection(true)}>升级会员</button>
                  <button className="secondary-button" onClick={handleLogout}>退出登录</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
